import { GET, POST, PATCH, DELETE } from "../config";

/**
 * Listar certificados
 */
export const list = async ({ page = 1, branch = null, client = null, is_valid = null, is_agreement = null } = {}) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("page_size", 20);

  if (branch) params.append("branch", branch);
  if (client) params.append("client", client);
  if (is_valid !== null) params.append("is_valid", is_valid);
  if (is_agreement !== null) params.append("is_agreement", is_agreement);

  const response = await GET(`inventory/certificates/?${params.toString()}`);
  return response.data;
};

/**
 * Crear certificado
 */
export const create = async (data) => {
  const response = await POST("inventory/certificates/", data);
  return response.data;
};

/**
 * Actualizar certificado
 */
export const update = async (id, data) => {
  const response = await PATCH(`inventory/certificates/${id}/`, data);
  return response.data;
};

/**
 * Eliminar certificado
 */
export const deleteCertificate = async (id) => {
  const response = await DELETE(`inventory/certificates/${id}/`);
  return response.data;
};

/**
 * Generar PDF del certificado
 */
export const generatePdf = async (id) => {
  const response = await POST(`inventory/certificates/${id}/generate_pdf/`);
  return response.data;
};

/**
 * Descargar PDF del certificado
 */
export const downloadPdf = async (id) => {
  const response = await GET(`inventory/certificates/${id}/download_pdf/`, {
    responseType: "blob",
  });
  return response.data;
};

/**
 * Obtener vista previa HTML del certificado
 */
export const previewHtml = async (id) => {
  const response = await GET(`inventory/certificates/${id}/preview_html/`);
  return response.data;
};

/**
 * Revocar certificado
 */
export const revoke = async (id, reason) => {
  const response = await POST(`inventory/certificates/${id}/revoke/`, { reason });
  return response.data;
};

/**
 * Verificar certificado (público - no requiere autenticación)
 */
export const verify = async (verificationCode) => {
  const response = await POST("inventory/certificates/verify/", {
    verification_code: verificationCode,
  });
  return response.data;
};

/**
 * Obtener estadísticas de certificados
 */
export const getStats = async (branch = null) => {
  const params = new URLSearchParams();
  if (branch) params.append("branch", branch);

  const response = await GET(`inventory/certificates/stats/?${params.toString()}`);
  return response.data;
};

/**
 * TEMPLATES
 */

/**
 * Listar plantillas de certificados
 */
export const listTemplates = async ({ page = 1, branch = null } = {}) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("page_size", 20);

  if (branch) params.append("branch", branch);

  const response = await GET(`inventory/certificate-templates/?${params.toString()}`);
  return response.data;
};

/**
 * Crear plantilla
 */
export const createTemplate = async (data) => {
  const response = await POST("inventory/certificate-templates/", data);
  return response.data;
};

/**
 * Actualizar plantilla
 */
export const updateTemplate = async (id, data) => {
  const response = await PATCH(`inventory/certificate-templates/${id}/`, data);
  return response.data;
};

/**
 * Eliminar plantilla
 */
export const deleteTemplate = async (id) => {
  const response = await DELETE(`inventory/certificate-templates/${id}/`);
  return response.data;
};

/**
 * CONVENIOS DE PAGO APR
 */

/**
 * Crear convenio de pago APR completo
 * Anula ingresos pendientes y crea certificado de convenio
 */
export const createAgreement = async (data) => {
  const response = await POST("inventory/certificates/create_agreement/", data);
  return response.data;
};

/**
 * Obtener cuotas de un convenio de pago
 * GET /certificates/{id}/installments/
 */
export const getInstallments = async (certificateId) => {
  const response = await GET(`inventory/certificates/${certificateId}/installments/`);
  return response.data;
};

/**
 * Pagar una cuota específica del convenio
 * POST /certificates/{id}/pay_installment/
 */
export const payInstallment = async (certificateId, data) => {
  const response = await POST(`inventory/certificates/${certificateId}/pay_installment/`, data);
  return response.data;
};
